import { Injectable, inject } from '@angular/core';
import {
  productFruits,
  ProductFruitsInitOptions,
  ProductFruitsUserObject,
} from 'product-fruits';
import { AuthService } from '@nimmsta/ng-commons-lib/auth';
import { LanguageService } from '@nimmsta/ng-commons-lib/services/language';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProductFruitsService {
  private languageService = inject(LanguageService);
  private auth = inject(AuthService);

  private lastInitializationKey?: string;

  public serviceInit() {
    this.languageService.languageChange.subscribe(() => {
      this.checkIfUserIsLoggedInAndInit();
    });
  }

  private checkIfUserIsLoggedInAndInit() {
    this.auth.getCurrentUser().subscribe((user) => {
      const initializationKey = `${this.languageService.getPreferredLanguage()}:${user.email}`;
      if (this.lastInitializationKey === initializationKey) {
        return;
      }
      this.destroy();
      this.lastInitializationKey = initializationKey;
      this.init({ username: user.email });
    });
  }

  private init(
    userObject: ProductFruitsUserObject,
    options?: ProductFruitsInitOptions | undefined,
  ) {
    const key = environment.PRODUCT_FRUITS_KEY;
    const lang = this.languageService.getPreferredLanguage();
    productFruits.init(key, lang, userObject, options);
  }

  private isLoaded() {
    return window.productFruitsIsReady;
  }

  public destroy() {
    if (this.isLoaded()) {
      // Use the current Product Fruits API to destroy the instance
      productFruits.safeExec(($productFruits) => {
        $productFruits.push(['destroy']);
      });
    }
  }
}
